import React from "react";
import { CarInfoProvider } from "./CarInfoContext";
import { BikeInfoProvider } from "./BikeInfoContext";
import { GeneralInfoProvider } from "./generalContext";
import { AuthProvider } from "./authContext";

export const CombineProviders = ({ children }) => {
  return (
    // <AuthProvider>
    <CarInfoProvider>
      <BikeInfoProvider>
        <GeneralInfoProvider>{children}</GeneralInfoProvider>
      </BikeInfoProvider>
    </CarInfoProvider>
    // </AuthProvider>
  );
};
